module.exports = __webpack_public_path__ + "img/google-play-logo.032d0455.png";